import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/NOBG.png"; // Pastikan gambar sudah benar
import Home2 from "./Home2";
import Type from "./Type";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home" style={{ backgroundColor: '#1e1d1d' }}>
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> JOSEPHIN NOVA</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
                {/* --- TEKS DESKRIPSI (SUDAH DIPERBAIKI: "He") --- */}
                <p className="home-description-text" style={{ paddingTop: '20px' }}>
                  A digital architect who designs the blueprints for complex systems. 
                  He doesn't just lay bricks (code), but designs the entire 
                  foundation, supporting structures, and infrastructure (databases, APIs) 
                  to ensure the structure is robust, secure, and scalable enough 
                  to accommodate thousands of users.
                </p>
                {/* ---------------------------------- */}
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ 
                  maxHeight: "450px", 
                  maxWidth: "450px", 
                  borderRadius: "50%", 
                  objectFit: "cover" 
                }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      
      <Home2 />

      <Container fluid style={{ backgroundColor: '#1e1d1d' }}> 
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ufftz4s"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/josephinnova"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ufftz4s?igsh=dGcxMTlvMjVreW1o&utm_source=qr"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;